import { AnyAction } from "redux"
import { clone, cloneDeep } from 'lodash';
import { FETCH_COMPANIES, FETCH_COMPANIES_COMBO, FETCH_UNIDS, FILTER_COMPANIES, RESET, SET_IDS_UNIDS } from "../actions/company";
import Company from "../../models/core/company/Company";

interface ILogin{
    companies: Company[] | null;
    companiesCombo: any[];
    idsUnids: any | null;
}

const initialState: ILogin = {
    companies: [],
    companiesCombo: [],
    idsUnids: null,
}

export const CompanyReducer = (state = initialState, action: AnyAction) =>{
    switch(action.type){
        case RESET:{
            return {
                ...cloneDeep(initialState)
            }
        }
        case FETCH_COMPANIES:{
            
            return{
                ...cloneDeep(state),
                companies: action.companies
            }
        }
        case FILTER_COMPANIES:{
            return{
                ...cloneDeep(state),
                companies: action.filteredCompanies
            }
        }
        case FETCH_COMPANIES_COMBO:{
            return{
                ...cloneDeep(state),
                companiesCombo: action.companiesCombo
            }
        }
        case SET_IDS_UNIDS: {
            return{
                ...cloneDeep(state),
                idsUnids: action.idsUnids
            }
        }
        default:{
            return state 
        }
    }
}